// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39150513","457":"539f8d88","851":"f9eedc76"}[chunkId] + ".chunk.js";
};